(function () {
  const root = document.querySelector('[data-promise]');
  if (!root) return;

  const btn = root.querySelector('.promise-float__btn');
  const drawer = root.querySelector('.promise-drawer');
  const overlay = root.querySelector('[data-promise-overlay]');
  const closeBtn = root.querySelector('[data-promise-close]');

  const open = () => {
    overlay.hidden = false;
    drawer.hidden = false;

    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    });

    document.documentElement.style.overflow = 'hidden';
  };

  const close = () => {
    drawer.classList.remove('is-open');
    btn.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';

    setTimeout(() => {
      drawer.hidden = true;
      overlay.hidden = true;
    }, 260);
  };

  btn.addEventListener('click', (e) => {
    // click on small X => hide widget
    if (e.target.classList.contains('promise-float__close')) {
      root.style.display = 'none';
      return;
    }
    drawer.classList.contains('is-open') ? close() : open();
  });

  overlay.addEventListener('click', close);
  closeBtn.addEventListener('click', close);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });
})();
